import { Link } from "react-router-dom";
import { Users, TrendingUp } from "lucide-react";
import CountdownTimer from "./CountdownTimer";

export default function AuctionCard({ auction }) {
  const savingsPercent =
    auction.retail_price > 0
      ? Math.max(0, 100 - Math.round((auction.current_price / auction.retail_price) * 100))
      : 0;

  return (
    <Link
      to={`/auction/${auction.id}`}
      data-testid={`auction-card-${auction.id}`}
      className="card-surface p-5 flex flex-col gap-4 transition-transform hover:-translate-y-1"
    >
      <div className="relative aspect-square rounded-lg overflow-hidden bg-black">
        <img
          src={auction.image_url}
          alt={auction.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <span className={`chip ${auction.status === "live" ? "chip-live" : "chip-closed"}`}>
            {auction.status === "live" ? "● Live" : "Closed"}
          </span>
        </div>
        <div className="absolute top-3 right-3 bg-black/70 backdrop-blur px-2 py-1 rounded-md text-[10px] font-bold text-[#FBBF24] border border-[#FBBF24]/30">
          -{savingsPercent}%
        </div>
      </div>

      <div>
        <h3 className="font-display font-bold text-base leading-tight mb-1 line-clamp-1">
          {auction.title}
        </h3>
        <div className="text-xs text-zinc-500">
          Retail <span className="line-through">${auction.retail_price.toFixed(2)}</span>
        </div>
      </div>

      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-1">Current Bid</div>
          <div className="font-mono-nums font-bold text-2xl text-[#FBBF24]">
            ${auction.current_price.toFixed(2)}
          </div>
        </div>
        <CountdownTimer endsAt={auction.ends_at} status={auction.status} />
      </div>

      <div className="flex items-center justify-between text-xs text-zinc-400 pt-3 border-t border-white/5">
        <span className="flex items-center gap-1.5">
          <Users size={12} /> {auction.bid_count} bids
        </span>
        <span className="flex items-center gap-1.5 text-zinc-500">
          <TrendingUp size={12} /> {auction.progress_percent}% to close
        </span>
      </div>
    </Link>
  );
}
